export default __webpack_public_path__ + "static/5-16745f04c5d82ba104a6cd07bbbc330e.png";